<div class="content grid cols-2">
	<div class="content layout-auto-1">
		<div class="md-menu-header">{{getGlobal('PopupHeaderFilter')}}</div>
		<div class="content">
			<ng-container *ngFor="let f of uiFilter; let i = index;">
				<ng-container *ngIf="f.filterType==1">
					<h3 *ngIf="i == 0 || i > 0 && f.filterGroup != uiFilter[i-1].filterGroup">{{getTranslation(f.filterGroup)}}</h3>
					<exg-switch [caption]="getTranslation(f.uiCaption)" name="{{f.uiName}}" style="overflow: visible"
					            [(ngModel)]="f.uiValue"  [tooltip]="f.uiTooltip"></exg-switch>
				</ng-container>
			</ng-container>
		</div>
	</div>
	<div class="content layout-auto-1">
		<div class="md-menu-header">{{getGlobal('PopupHeaderSearch')}}</div>
		<div class="content">
			<ng-container *ngFor="let f of uiFilter; let i = index;">
			<ng-container *ngIf="f.filterType==2">
				<h4 *ngIf="i == 0 || i > 0 && f.filterGroup != uiFilter[i-1].filterGroup">{{getTranslation(f.filterGroup)}}</h4>
				<exg-input [caption]="getTranslation(f.uiCaption)" name="{{f.uiName}}"
				           [(ngModel)]="f.filterCondition.value" [tooltip]="f.uiTooltip"></exg-input>
			</ng-container>
		</ng-container>s
		</div>
	</div>
</div>
